// --------------------------------------------------------------
// Created On: 2021-05-14
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./TextBlurb.module.scss";

// Title, paragraph, and icon text.
export default function TextBlurb(props: Props): Component {
  return (
    <div className={`${styles.body} mx-auto`}>
      <h3>{props.title}</h3>
      <p className="mb-3 mx-auto">{props.paragraph}</p>
      <i className={`fa fa-fw fa-${props.icon} fa-3x`} />
    </div>
  );
}

interface Props {
  title: string;
  paragraph: string;
  icon: string;
}
